import { type ComponentProps } from "react";
import { Button } from "@/shared/components/ui/button";
import { cn } from "@/shared/lib/utils";

/**
 * The funnel's commitment button — deep operative red with a gold hairline,
 * serif label. Wraps the shadcn Button (never modify the primitive).
 */
export function MissionButton({
  className,
  ...props
}: ComponentProps<typeof Button>) {
  return (
    <Button
      size="lg"
      className={cn(
        "h-auto min-w-[9rem] flex-1 whitespace-normal rounded-lg border border-border",
        "bg-gradient-to-b from-[oklch(0.4_0.14_27)] to-[oklch(0.28_0.11_27)]",
        "px-4 py-3.5 font-serif text-[15px] tracking-wide text-[oklch(0.9_0.06_85)]",
        "shadow-[0_6px_18px_rgba(0,0,0,0.45),inset_0_1px_0_rgba(255,255,255,0.08)]",
        "transition hover:-translate-y-px hover:brightness-110 hover:shadow-[0_10px_26px_rgba(0,0,0,0.5)]",
        className,
      )}
      {...props}
    />
  );
}

/** Understated underlined text action ("Reconsider", "Run it again"). */
export function QuietButton({ className, ...props }: ComponentProps<"button">) {
  return (
    <button
      className={cn(
        "mx-auto mt-6 block cursor-pointer font-serif text-sm text-muted-foreground underline underline-offset-4 transition-colors hover:text-foreground",
        className,
      )}
      {...props}
    />
  );
}
